import React from 'react';

/**
 * Per-user active-days detail modal for Most active users. Rendered from data
 * already loaded on the row (no extra fetch).
 *
 * Props: { open, userName, dates, onClose }
 *   dates: [{ day, activity_count, new_open, resume }]
 */
const formatDay = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
};

const ActiveDaysModal = ({ open, userName, dates = [], onClose }) => {
  if (!open) return null;
  return (
    <div className="au-modal-bg" data-testid="au-modal" onClick={onClose}>
      <div className="au-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="au-modal-close" onClick={onClose} aria-label="Close" title="Close">×</button>
        <h2 className="au-modal-title">{userName || '-'}</h2>
        <table className="au-modal-table">
          <thead>
            <tr><th>Day (UTC)</th><th>Activity count</th><th>New Open</th><th>Resume</th></tr>
          </thead>
          <tbody>
            {dates && dates.length > 0 ? (
              dates.map((d, i) => (
                <tr key={i}>
                  <td data-label="Day (UTC)">{formatDay(d.day)}</td>
                  <td data-label="Activity count" className="au-num-blue">{d.activity_count || 0}</td>
                  <td data-label="New Open" className="au-num-green">{d.new_open || 0}</td>
                  <td data-label="Resume" className="au-num-purple">{d.resume || 0}</td>
                </tr>
              ))
            ) : (
              <tr><td className="au-modal-empty" colSpan="4">No active dates found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActiveDaysModal;
